import React from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { DownloadOutlined as SystemUpdateAltIcon } from '@ant-design/icons';
import { Button, Spin } from 'antd';

import affiliateService from 'v2/services/affiliate';

export const Export = () => {
  const [loading] = useObservable(() => affiliateService.loadingExporting(), []);
  const [handleClickExport] = useCallbackObservable(() => affiliateService.export(), []);
  const [totalItems] = useObservable(() => affiliateService.getTotalItems(), []);

  return (
    <Button
      className='px-4 text-[#37474F]'
      disabled={!totalItems || loading}
      onClick={handleClickExport}
      type='text'
      icon={loading ? <Spin size='small' /> : <SystemUpdateAltIcon />}
    >
      {!loading ? 'Exportar' : 'Exportando...'}
    </Button>
  );
};
